import { registerPlugin } from '@capacitor/core';

export interface DownloadOptions {
  url: string;
  fileName: string;
  mimeType?: string;
}

export interface DownloadResult {
  success: boolean;
  uri?: string;
  /** Final name written to Downloads, after de-duplication (e.g. "photo (1).jpg"). */
  fileName?: string;
}

export interface OpenRemotePdfOptions {
  url: string;
  fileName?: string;
}

export interface OpenRemotePdfResult {
  opened: boolean;
}

export interface DownloadsPlugin {
  downloadToDownloads(options: DownloadOptions): Promise<DownloadResult>;
  /**
   * Android only. Streams a remote PDF to the app cache and opens it in the device's
   * native PDF viewer via FileProvider + ACTION_VIEW. Rejects with "no-viewer" when no
   * app can open it, or "download-failed" on network/IO errors.
   */
  openRemotePdf(options: OpenRemotePdfOptions): Promise<OpenRemotePdfResult>;
}

// Name MUST match @CapacitorPlugin(name = "Downloads") on the native side.
export const Downloads = registerPlugin<DownloadsPlugin>('Downloads');
